import classes from "./assets/styles/styles.scss";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import ConfirmationCheckoutPage from "./pages/confirmation-checkout-page";
import CongratsPage from "./pages/congrats-page";
import ConnectWalletPrivatePage from "./pages/connect-wallet-private-page";
import QueuePage from "./pages/queue-page";
import QuizPage from "./pages/quiz-page";
import ShippingInformationPage from "./pages/shipping-information-page";
import RouterPage from "./pages/router-page";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<RouterPage/>} />
      </Routes>
    </Router>
  );
}

export default App;
